<!-- Modal Header -->
        <div class="modal-header">
          <h5 class="modal-title" id="publisherModalLabel">{{ selectedPublisher?.name }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Đóng" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <!-- Modal Body -->
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6">
              <strong>Địa Chỉ:</strong> {{ selectedPublisher?.address }}<br />
              <strong>Email:</strong> {{ selectedPublisher?.email }}<br />
              <strong>Số Điện Thoại:</strong> {{ selectedPublisher?.phone }}<br />
            </div>
            <div class="col-md-6">
              <strong>Quốc Gia:</strong> {{ selectedPublisher?.country }}<br />
              <strong>Trang Web:</strong> <a [href]="selectedPublisher?.website" target="_blank">{{ selectedPublisher?.website }}</a><br />
            </div>
          </div>
        </div>
        <!-- Modal Footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary"  (click)="closeModal()" data-dismiss="modal">Đóng</button>
        </div>
